export default __webpack_public_path__ + "static/media/etapa5.223b6b7e.png";